import fetch from 'cross-fetch'
import getApiLocation from './getApiLocation'
import getParameterString from './getParameterString'
import parseContentDispositionFilename from './parseContentDispositionFilename'
import { getAuthToken } from '@/lib/authentication'
import validateResult from './validateResult'

// The SPA's blob-download helper. Every other export builds a file in the browser with the xlsx
// package; this is the one path where the bytes and the name are the server's. It reads the
// response as a Blob rather than JSON, honours the server's Content-Disposition name, and saves it
// through an object URL. Unlike opening the URL in a new window, the token rides in the header, not
// the query string, so it never lands in history.
const saveBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  // Defer the revoke: some browsers abort a download whose object URL is revoked in the same tick
  // as the click, before the save has begun.
  setTimeout(() => window.URL.revokeObjectURL(url), 0)
}

const getFile = ({ path, parameters = {}, fallbackFileName = 'download' }) => {
  const apiLocation = getApiLocation()
  const query = getParameterString(parameters)

  return fetch(`${apiLocation}/${path}${query}`, {
    method: 'GET',
    headers: {
      'Authorization': 'Bearer ' + getAuthToken()
    }
  })
    .then(res => {
      if (res.status === 401) {
        validateResult(res)
        return
      }

      if (res.status >= 400) {
        // A rejected download still returns the JSON envelope, so read the reason out of it
        // rather than the status line.
        return res.json().catch(() => null).then(body => {
          throw new Error((body && body.errorMessage) || 'File download failed.')
        })
      }

      const fileName = parseContentDispositionFilename(res.headers.get('Content-Disposition'), fallbackFileName)
      return res.blob().then(blob => saveBlob(blob, fileName))
    })
}

export default getFile
